import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Dashboards/Header";
import Home from "./Home";
import Landing from "./Dashboards/Landing";
import CompanyDetailView from "./Dashboards/CompanyDetailView";
import CompanyDetailUpdate from "./Dashboards/CompanyDetailUpdate";
import { ToastContainer } from "react-toastify";
import Sidebar from "./Dashboards/Sidebar";
import { Provider } from "react-redux";
import store from "./store";
import Login from "./commonComponents/Login"
import SignUp from "./commonComponents/SignUp";
import ProtectedRoute from "./commonComponents/ProtectedRoute";
import CommunicationList from "./Dashboards/Communication/CommunicationList";
import TemplateSelector from "./Dashboards/TemplateSelector"
import TemplateForm from "./Dashboards/TemplateForm";
import TemplateList from "./Dashboards/TemplateList";
import EditTemplateForm from "./Dashboards/EditTemplateForm"
import ForgotPassword from "./commonComponents/ForgotPassword";
import ResetPassword from "./commonComponents/ResetPassword";
import CasualTech from "./CasualTech";
import DomainSearch from "./Dashboards/DomainSearch"


const App = () => {

  return (
    <div className="container" style={{ marginTop: "0px" }}>
      <Provider store={store}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* add your normal routes like /login, /register, etc. */}
          <Route path="/signup" element={<SignUp />} />
          <Route path="/start" element={<Home />} />
          <Route path="/" element={<CasualTech />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Landing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/company-detail/:id"
            element={
              <ProtectedRoute>
                <CompanyDetailView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/company-detail-update/:id"
            element={
              <ProtectedRoute>
                <CompanyDetailUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/communication"
            element={
              <ProtectedRoute>
                <CommunicationList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/templateSelection"
            element={
              <ProtectedRoute>
                <TemplateSelector />
              </ProtectedRoute>
            }
          />
          <Route
            path="/templateList"
            element={
              <ProtectedRoute>
                <TemplateList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/createTemplate"
            element={
              <ProtectedRoute>
                <TemplateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editTemplate/:id"
            element={
              <ProtectedRoute>
                <EditTemplateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/domainSearch"
            element={
              <ProtectedRoute>
                <DomainSearch />
              </ProtectedRoute>
            }
          />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </Provider>
    </div>
  );
};

export default App;
